import { useEffect } from "react";
import { useGenerateTenantSearchKey } from "./use-generate-tenant-search-key";
import useStore from "./use-store";
import { useGenerateSiteSearchKey } from "./use-generate-site-search-key";
import { useGenerateSecuritySearchKey } from "./use-generate-security-search-key";

export const useMeilisearchApiKey = (enabled: boolean = true) => {
  const { user } = useStore();
  const meilisearchToken = user.meilisearchToken;
  const setMeilisearchToken = user.setMeilisearchToken;
  const viewContext = user.viewContext;

  const { data: newMeilisearchTenantToken } = useGenerateTenantSearchKey(
    viewContext === "tenant" && enabled,
  );

  const { data: newMeilisearchSiteToken } = useGenerateSiteSearchKey(
    viewContext === "site" && enabled,
  );

  const { data: newMeilisearchSecurityToken } = useGenerateSecuritySearchKey(
    viewContext === "security" && enabled,
  );

  useEffect(() => {
    if (viewContext === "tenant") {
      if (newMeilisearchTenantToken && newMeilisearchTenantToken !== meilisearchToken) {
        setMeilisearchToken(newMeilisearchTenantToken);
      }
    } else if (viewContext === "site") {
      if (newMeilisearchSiteToken && newMeilisearchSiteToken !== meilisearchToken) {
        setMeilisearchToken(newMeilisearchSiteToken);
      }
    } else if (viewContext === "security") {
      if (newMeilisearchSecurityToken && newMeilisearchSecurityToken !== meilisearchToken) {
        setMeilisearchToken(newMeilisearchSecurityToken);
      }
    }
  }, [
    meilisearchToken,
    newMeilisearchSiteToken,
    newMeilisearchTenantToken,
    newMeilisearchSecurityToken,
    setMeilisearchToken,
    viewContext,
  ]);
};
